/**
 * Backline exclusions for the RIDER PDF (and its config mirror table).
 *
 * Some backline items are NOT backline: they print in their OWN rider section,
 * so keeping them in the Backline table duplicates them (user 2026-10-18,
 * measured on Kadebostany's real data: types `wedge`, `sub`, `stand`).
 *   - monitor wedges + subwoofers → MONITORS section (v0.779)
 *   - mic stands                  → MIC STANDS section (v0.648)
 *
 * Types are FREE-FORM user strings (useBacklineTypes), so the match is a
 * normalised, word-boundary regex over type + label. Deliberately NOT
 * excluded: keyboard stands, guitar stands, microphones (wired/wireless —
 * they print under Wireless transmitters / Input list, but the user only
 * asked wedges/subs and mic stands out of Backline. Wireless microphones
 * joined them (2026-10-18, second report): a wireless mic/bodypack item in
 * the Backline list duplicates the WIRELESS TRANSMITTERS table (per-person,
 * with mic/receiver providers) — a WIRED or ambiance microphone does NOT
 * print there, so it stays in Backline.
 */
const MONITOR_RE = /\b(wedges?|monitors?|monitoring|subwoofers?|subs)\b/i;
const MIC_STAND_RE = /\b(mic(rophone)?\s*stands?|boom\s*stands?|stands?\s+for\s+micros?)\b/i;
const WIRELESS_MIC_RE = /\bwireless\b/i;
const MICISH_RE = /\b(mics?|microphones?|handhelds?|bodypacks?|transmitters?)\b/i;

export function excludedFromBackline(type?: string, label?: string): boolean {
  const s = `${type || ''} ${label || ''}`;
  if (MONITOR_RE.test(s) || MIC_STAND_RE.test(s)) return true;
  // A wireless microphone item → covered by the Wireless Transmitters table.
  return WIRELESS_MIC_RE.test(s) && MICISH_RE.test(s);
}
